var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jy-main-mainbooks container",attrs:{"flex":"","between":""}},[_c('mainbooksL',{attrs:{"options":_vm.options}}),(_vm.main_right.length)?_c('mainBookR',{attrs:{"options":_vm.main_right}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }